export default __webpack_public_path__ + "static/media/messenger.d920de5c.svg";